import React from 'react';
import { FaEnvelope, FaPhone } from 'react-icons/fa';

const Contact = () => {
    return (
        <div id="contact" className="architectural-bg" style={{ padding: 'var(--section-padding)', borderTop: '1px solid rgba(255,255,255,0.05)' }}>
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                        <h2 className="section-head-main mb-4">Get In Touch</h2>
                        <p className="mb-5" style={{ color: 'var(--text-secondary)', maxWidth: '600px', margin: '0 auto', lineHeight: '1.8' }}>
                            Ready to discuss your next project? We're here to provide expert consultation and professional services.
                        </p>

                        <div className="d-flex flex-wrap justify-content-center gap-4">
                            {/* Email Card */}
                            <div className="arch-card p-4 d-flex flex-column align-items-center text-center" style={{ minWidth: '280px', flex: '1', maxWidth: '350px' }}>
                                <div className="mb-3" style={{ color: 'var(--secondary-color)', fontSize: '1.5rem' }}>
                                    <FaEnvelope />
                                </div>
                                <div>
                                    <span className="section-index" style={{ fontSize: '0.6rem' }}>EMAIL ADDRESS</span>
                                    <a href="mailto:waseeq@alwaseeqdesign.com" className="m-0 d-block text-white text-decoration-none contact-link" style={{ fontSize: '1.1rem', letterSpacing: '1px' }}>
                                        waseeq@alwaseeqdesign.com
                                    </a>
                                </div>
                            </div>

                            {/* Phone Card */}
                            <div className="arch-card p-4 d-flex flex-column align-items-center text-center" style={{ minWidth: '280px', flex: '1', maxWidth: '350px' }}>
                                <div className="mb-3" style={{ color: 'var(--secondary-color)', fontSize: '1.5rem' }}>
                                    <FaPhone />
                                </div>
                                <div>
                                    <span className="section-index" style={{ fontSize: '0.6rem' }}>CONTACT NUMBER</span>
                                    <a href="tel:+919843524706" className="m-0 d-block text-white text-decoration-none contact-link" style={{ fontSize: '1.1rem', letterSpacing: '1px' }}>
                                        +91 98435 24706
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <style>{`
                .contact-link {
                    transition: all 0.3s ease;
                }
                .contact-link:hover {
                    color: var(--secondary-color) !important;
                    transform: translateX(5px);
                }
            `}</style>
        </div>
    );
};

export default Contact;
